<footer class="footer bg-dark rounded-top text-center">
    <div class="container py-2 text-center">
      <p class="text-white my-2">
                Sofipa Corporation S.A.P.I de C.V. SOFOM E.N.R <br/>
                &copy; Todos los derechos reservados. Términos de uso y privacidad.
      </p>
    </div>
  </footer>
  